export class LoadingIcon {
    #element;
    #blocks;

    #tsLastUpdate;
    #counter = 0;
    #playing;
    #delay = 50;
    #playResolve;
    #pauseResolve;

    get element() {
        return this.#element;
    }

    get playing() {
        return this.#playing;
    }

    get delay() {
        return this.#delay;
    }

    set delay(value) {
        if(typeof value !== 'number')
            value = parseFloat(value);
        if(isNaN(value) || !isFinite(value))
            return;
        if(value < 0)
            value = Math.abs(value);
        this.#delay = value;
    }

    constructor(playing=false) {
        this.#element = <div class="msz-loading-icon" />;
        for(let i = 0; i < 9; ++i)
            this.#element.appendChild(<div class="msz-loading-icon-block" />);

        // this is moderately cursed but it'll do
        this.#blocks = [
            this.#element.children[3],
            this.#element.children[0],
            this.#element.children[1],
            this.#element.children[2],
            this.#element.children[5],
            this.#element.children[8],
            this.#element.children[7],
            this.#element.children[6],
        ];

        if(this.#playing = playing)
            requestAnimationFrame(ts => { this.#update(ts) });
    }

    #update(tsCurrent) {
        try {
            if(this.#tsLastUpdate !== undefined && (tsCurrent - this.#tsLastUpdate) < this.#delay)
                return;
            this.#tsLastUpdate = tsCurrent;

            for(let i = 0; i < this.#blocks.length; ++i)
                this.#blocks[(this.#counter + i) % this.#blocks.length].classList.toggle('msz-loading-icon-block-hidden', i < 3);

            ++this.#counter;
        } finally {
            if(this.#playResolve)
                try {
                    this.#playResolve();
                } finally {
                    this.#playResolve = undefined;
                    this.#playing = true;
                }

            if(this.#pauseResolve)
                try {
                    this.#pauseResolve();
                } finally {
                    this.#pauseResolve = undefined;
                    this.#playing = false;
                }

            if(this.#playing)
                requestAnimationFrame(ts => { this.#update(ts) });
        }
    }

    play() {
        return new Promise(resolve => {
            if(this.#playing || this.#playResolve) {
                resolve();
                return;
            }

            this.#playResolve = resolve;
            requestAnimationFrame(ts => { this.#update(ts) });
        });
    }

    pause() {
        return new Promise(resolve => {
            if(!this.#playing || this.#pauseResolve) {
                resolve();
                return;
            }

            this.#pauseResolve = resolve;
        });
    }

    async stop() {
        await this.pause();
        this.#counter = 0;
    }

    async restart() {
        await this.stop();
        await this.play();
    }

    reverse() {
        this.#blocks.reverse();
    }

    #setBlock(num, state=null) {
        this.#element.children[num].classList.toggle('msz-loading-icon-block-hidden', !state);
    }

    batsu() {
        this.#setBlock(0, true);  this.#setBlock(1, false); this.#setBlock(2, true);
        this.#setBlock(3, false); this.#setBlock(4, true);  this.#setBlock(5, false);
        this.#setBlock(6, true);  this.#setBlock(7, false); this.#setBlock(8, true);
    }

    maru() {
        this.#setBlock(0, true); this.#setBlock(1, true);  this.#setBlock(2, true);
        this.#setBlock(3, true); this.#setBlock(4, false); this.#setBlock(5, true);
        this.#setBlock(6, true); this.#setBlock(7, true);  this.#setBlock(8, true);
    }
}

export class LoadingIndicator {
    #element;
    #icon;

    get element() {
        return this.#element;
    }

    get hasIcon() {
        return this.#icon !== undefined;
    }
    get icon() {
        return this.#icon;
    }

    get visible() {
        return !this.#element.classList.contains('hidden');
    }
    set visible(state) {
        this.#element.classList.toggle('hidden', !state);
    }

    constructor({
        element=null, size=null, colour=null,
        width=null, height=null, inline=null,
        containerWidth=null, containerHeight=null,
        gap=null, margin=null, hidden=null,
    } = {}) {
        if(typeof element === 'string')
            element = document.querySelector(element);
        if(!(element instanceof HTMLElement))
            element = <div class="msz-loading"/>;
        this.#element = element;

        if(!element.classList.contains('msz-loading'))
            element.classList.add('msz-loading');
        if(inline)
            element.classList.add('msz-loading-inline');
        if(hidden)
            element.classList.add('hidden');

        if(typeof size === 'number' && size > 0)
            element.style.setProperty('--msz-loading-size', size);
        if(typeof containerWidth === 'string')
            element.style.setProperty('--msz-loading-container-width', containerWidth);
        if(typeof containerHeight === 'string')
            element.style.setProperty('--msz-loading-container-height', containerHeight);
        if(typeof gap === 'string')
            element.style.setProperty('--msz-loading-gap', gap);
        if(typeof margin === 'string')
            element.style.setProperty('--msz-loading-margin', margin);
        if(typeof width === 'string')
            element.style.setProperty('--msz-loading-width', width);
        if(typeof height === 'string')
            element.style.setProperty('--msz-loading-height', height);
        if(typeof colour === 'string')
            element.style.setProperty('--msz-loading-colour', colour);

        if(element.childElementCount < 1) {
            this.#icon = new LoadingIcon(true);
            element.appendChild(<div class="msz-loading-frame">{this.#icon}</div>);
        }
    }
}
